import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M3 5v1H2V5h1zm0-1H2a1.003 1.003 0 0 0-1 1v1c.002.552.448.998 1 1h1a1.003 1.003 0 0 0 1-1V5a1.003 1.003 0 0 0-1-1zM6 5h13v1H6V5zM3 10v1H2v-1h1zm0-1H2a1.003 1.003 0 0 0-1 1v1c.002.552.448.998 1 1h1a1.003 1.003 0 0 0 1-1v-1a1.003 1.003 0 0 0-1-1zM6 10h13v1H6v-1zM3 15v1H2v-1h1zm0-1H2a1.003 1.003 0 0 0-1 1v1c.002.552.448.998 1 1h1a1.003 1.003 0 0 0 1-1v-1a1.003 1.003 0 0 0-1-1zM6 15h13v1H6v-1z',
  ],
  height: 20,
  width: 20,
});
